///var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/pages/ExploreInternet.js

import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import InternetView from '../components/Content/InternetView';
import InternetHeaderView from '../components/Content/InternetHeaderView';

import Sidebar from './Sidebar';
import Header from '../components/Header';
import { ProgressSpinner } from 'primereact/progressspinner';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import '../css/Member.css';
import {
  fetchPromotions,
  insertPromotion,
  updatePromotion,
  deletePromotion,
  fetchInternetHeaderCategories,
  insertInternetHeaderCategory,
  updateInternetHeaderCategory,
  deleteInternetHeaderCategory
} from '../utils/ExploreInternetHandlers';

const ExploreInternet = () => {
  const location = useLocation();
  const isHeaderView = location.pathname === '/explore-internet-header';

  // State สำหรับ promotions และ headers
  const [promotions, setPromotions] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [pageLength, setPageLength] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  // ดึงข้อมูลจาก API ตามประเภท view
  const fetchData = async (currentPage, pageLength) => {
    setIsLoading(true);
    try {
      if (isHeaderView) {
        const data = await fetchInternetHeaderCategories();
        setHeaders(data);
        setTotalCount(data.length);
      } else {
        const promotionList = await fetchPromotions();
        const startIndex = (currentPage - 1) * pageLength;
        const endIndex = startIndex + pageLength;
        const paginatedData = promotionList.slice(startIndex, endIndex);
        setPromotions(paginatedData);
        setTotalCount(promotionList.length);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // ฟังก์ชัน refresh table
  const refreshTable = async () => {
    await fetchData(currentPage, pageLength);
  };

  // Insert handler
  const handleInsert = async (data) => {
    try {
      if (isHeaderView) {
        const response = await insertInternetHeaderCategory(data);
        await refreshTable();
        return response;
      } else {
        const response = await insertPromotion(data);
        await refreshTable();
        return response;
      }
    } catch (error) {
      console.error('Error inserting:', error);
      throw error;
    }
  };

  // Update handler
  const handleUpdate = async (data) => {
    try {
      if (isHeaderView) {
        const response = await updateInternetHeaderCategory(data);
        await refreshTable();
        return response;
      } else {
        const response = await updatePromotion(data);
        await refreshTable();
        return response;
      }
    } catch (error) {
      console.error('Error updating:', error);
      throw error;
    }
  };

  // Delete handler
  const handleDelete = async (idOrKey) => {
    try {
      if (isHeaderView) {
        const response = await deleteInternetHeaderCategory(idOrKey);
        await refreshTable();
        return response;
      } else {
        const response = await deletePromotion(idOrKey);
        await refreshTable();
        return response;
      }
    } catch (error) {
      console.error('Error deleting:', error);
      throw error;
    }
  };

  // ปรับ pageLength
  const handlePageLengthChange = (e) => {
    setPageLength(parseInt(e.target.value, 10));
    setCurrentPage(1);
  };

  // ดึงข้อมูลครั้งแรก และทุกครั้งที่ currentPage/pageLength หรือ isHeaderView เปลี่ยน
  useEffect(() => {
    fetchData(currentPage, pageLength);
  }, [currentPage, pageLength, isHeaderView]);

  return (
    <div className="dashboard">
      <Sidebar />
      <div className="dashboard-main">
        <Header
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          placeholderText={isHeaderView ? 'Search header categories...' : 'Search promotions...'}
          refreshData={refreshTable}
        />
        <div className="p-datatable-details">
          <div className="member-table-container">
            {isLoading ? (
              <div className="text-center my-4">
                <ProgressSpinner
                  style={{ width: '50px', height: '50px' }}
                  strokeWidth="8"
                  fill="transparent"
                  animationDuration=".5s"
                />
              </div>
            ) : (
              isHeaderView ? (
                <InternetHeaderView
                  headers={headers}
                  setHeaders={setHeaders}
                  totalCount={totalCount}
                  searchQuery={searchQuery}
                  pageLength={pageLength}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  handlePageLengthChange={handlePageLengthChange}
                  handleInsertHeader={handleInsert}
                  handleUpdateHeader={handleUpdate}
                  handleDeleteHeader={handleDelete}
                  refreshData={refreshTable}
                />
              ) : (
                <InternetView
                  promotions={promotions}
                  setPromotions={setPromotions}
                  totalCount={totalCount}
                  searchQuery={searchQuery}
                  pageLength={pageLength}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  handlePageLengthChange={handlePageLengthChange}
                  handleInsertPromotion={handleInsert}
                  handleUpdatePromotion={handleUpdate}
                  handleDeletePromotion={handleDelete}
                  refreshTable={refreshTable}
                />
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExploreInternet;
